<template>
  <div class="bg-img">
    <div class="topheader">
      <div class="topheader__logo">
        <a href="http://hrdesk.africa/">
          <img src="./../../../assets/images/hrdesk-logo-dark-beta.png" alt="logo" />
        </a>
      </div>
      <div class="topheader__contact"></div>
    </div>

    <div class="signup-container">
      <div class="card">
        <h2 class="card-heading">Sign in</h2>
        <p class="card-text">Welcome</p>
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label for="email">Email</label>
            <input type="email" id="email" v-model="formData.email" placeholder="Email" />
            <span class="signup-error" v-if="errors.email">{{
              errors.email
              }}</span>
          </div>

          <div class="form-group">
            <label for="password">Password</label>
            <div class="password">
              <input
                :type="viewPassword ? 'text' : 'password'"
                id="password"
                v-model="formData.password"
                placeholder="Password"
              />
              <span v-if="viewPassword" @click="togglePassword" class="span"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-eye"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"
                  />
                  <path
                    d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"
                  /></svg
              ></span>
              <span v-else @click="togglePassword" class="span"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-eye-slash"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"
                  />
                  <path
                    d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"
                  />
                  <path
                    d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"
                  /></svg
              ></span>
            </div>

            <span class="signup-error" v-if="errors.password">{{
              errors.password
              }}</span>
          </div>

          <routerLink to="/forgot-password">
            <p class="forgotPassword">Forgot Password ?</p>
          </routerLink>

          <div v-if="errorMessage" class="error-message">
            <p class="signup-error">{{ errorMessage }}</p>
          </div>

          <div class="btn-container">
            <button role="button" type="submit">
              <span v-show="!loading">Submit</span>
              <span class="my-loader" v-show="loading">
                <WhiteLoader />
              </span>
            </button>
          </div>
        </form>

        <div>
          Don’t have an account?
          <routerLink to="/signup"><span class="forgotPassword">Sign Up</span></routerLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";

export default {
  name: "Login",

  components: {
    WhiteLoader,
  },
  data() {
    return {
      formData: {
        email: "",
        password: "",
      },
      errors: {},
      loading: false,
      errorMessage: null,
      viewPassword: false,
    };
  },
  metaInfo: {
    title: 'Login - HrDesk',
    meta: [
      { name: 'description', content: 'Login to access your account at HrDesk.' },
      { property: 'og:title', content: 'Login - HrDesk' },
      { property: 'og:description', content: 'Login to access your account at HrDesk.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://app.hrdesk.africa/login' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Login - HrDesk' },
      { name: 'twitter:description', content: 'Login to access your account at HrDesk.' },
      { name: 'keywords', content: 'login, sign in, user login, access account' },
    ]
  },
  methods: {
    handleChange(e) {
      const { name, value } = e.target;
      this.formData[name] = value;
    },

    handleSubmit() {
      this.errors = {};

      if (!this.formData.email.trim()) {
        this.errors.email = "Email is required";
      } else if (!/^\S+@\S+\.\S+$/.test(this.formData.email)) {
        this.errors.email = "Invalid email address";
      }

      if (!this.formData.password.trim()) {
        this.errors.password = "Password is required";
      }

      if (Object.keys(this.errors).length > 0) {
        return;
      }

      this.loading = true;
      const loginData = {
        email: this.formData.email,
        password: this.formData.password,
      };

      this.$store
        .dispatch(types.AUTH_REQUEST, loginData)
        .then((resp) => {
          if (this.$store.getters.userIsJobseeker) {
            return this.$router.push("/jobseeker-profile");
          }

          if (resp.data.data.user.email_verified_at === null) {
            return this.$router.push({
              path: "/verify-email",
              query: { email: resp.data.data.user.email },
            });
          }

          if (this.$store.getters.userIsAdmin) {
            return this.$router.push("/dashboard");
          }

          if (this.$store.getters.userIsUser) {
            return this.$router.push("/employee-portal");
          }

          return this.$router.push("/login");
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage = error.response.data.message;
          if (error.response.status) {
            if (error.response.status === 501) {
              this.networkError = true;
            } else {
              this.credentialsError = true;
            }
          }
        });
    },

    togglePassword() {
      this.viewPassword = !this.viewPassword;
    },
  },
};
</script>

<style scoped>
@import "./../../../assets/vendor/css/external.css";
@import "./../../../assets/vendor/css/style.css";

.password {
  position: relative;

  span {
    position: absolute;
    width: 4rem;
    padding: 1rem;
    top: 0;
    right: 0;
    color: #274980;
  }
}

.forgotPassword {
  font-weight: 800;
  color: #274980;
}

.signup-error {
  text-align: center;
  color: red;
  font-size: 0.9rem;
  font-style: italic;

  >p {
    margin: 0;
    margin-bottom: 0;

    &::first-letter {
      text-transform: capitalize;
    }
  }

  >div {
    padding-bottom: 5px;
    background: #162b4c;
  }
}

.bg-img {
  background-image: url("https://uniswitch-public-assets.s3.amazonaws.com/bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
}

.topheader {
  min-height: 50px;
  margin: auto;
  padding: 0 15px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;

  >.topheader__logo {
    max-width: 100px;
    margin-left: 2rem;

    >img {
      width: 100%;
    }
  }
}

.card-heading {
  color: black;
  margin-bottom: 0.5rem;
  font-size: 2.5rem;
}

.card-text {
  color: #1514138f;
  margin-bottom: 2rem;
}

.signup-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8rem;
}

.card {
  width: 90%;
  max-width: 700px;
  padding: 25px;
  border: 2px solid #93a4bf;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.form-group {
  flex-basis: 100%;
  margin-bottom: 10px;
  text-align: left;
  gap: 2rem;
}

label {
  display: block;
  margin-bottom: 10px;
  font-weight: semibold;
  color: #1514138f;
}

input {
  width: 100%;
  padding: 15px;
  border: 2px solid #93a4bf;
  border-radius: 8px;
  margin-bottom: 10px;
}

.btn-container {
  width: full;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
}

button {
  width: 15vw;
  height: 3.5rem;
  padding: 10px;
  background-color: #274980;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #162b4c;
}

@media (max-width: 750px) {
  button {
    width: 75vw;
  }
}
</style>
